import { Avatar, Ic } from '../../../components/ui'
import { DK, fmtDate, fmtMonth } from '../theme'
import { Card, SectionTitle, PoolThumb } from '../components/DashboardUI'

const INFO_CARDS = [
  { icon:'mail',  label:'EMAIL',       key:'email',
    bg:'linear-gradient(135deg,rgba(31,200,214,.18),rgba(10,123,134,.1))', border:'rgba(31,200,214,.25)',  color:'#1FC8D6' },
  { icon:'phone', label:'ТЕЛЕФОН',     key:'phone',
    bg:'linear-gradient(135deg,rgba(139,92,246,.18),rgba(109,40,217,.1))', border:'rgba(139,92,246,.25)', color:'#a78bfa' },
  { icon:'pin',   label:'ЛОКАЦИЯ',     key:'location',
    bg:'linear-gradient(135deg,rgba(251,146,60,.18),rgba(234,88,12,.1))',   border:'rgba(251,146,60,.25)', color:'#fb923c' },
  { icon:'info',  label:'РЕГИСТРАЦИЯ', key:'created',
    bg:'linear-gradient(135deg,rgba(59,130,246,.18),rgba(37,99,235,.1))',   border:'rgba(59,130,246,.25)', color:'#60a5fa' },
]

export default function ProfileTab({ user, projects, projectsLoading, resolveAssetUrl, projectNumberMap, c, goNewProject, onGoProjects }) {
  const name     = user?.name || 'Пользователь'
  const email    = user?.email || ''
  const location = [user?.city, user?.country].filter(Boolean).join(', ')
  const recent   = (projects || []).slice(0, 3)
  const dk       = c === DK

  const infoValues = {
    email:    email    || '—',
    phone:    user?.phone    || '—',
    location: location || '—',
    created:  fmtMonth(user?.created_at || user?.createdAt),
  }

  const projCount = projects.length
  const projWord  = projCount === 1 ? 'проект' : projCount < 5 ? 'проекта' : 'проектов'

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:20 }}>

      {/* Hero banner */}
      <div style={{
        borderRadius:20, padding:'28px 28px 24px', position:'relative', overflow:'hidden',
        background: dk
          ? 'linear-gradient(145deg,#030C1A 0%,#071422 50%,#0A1B2E 100%)'
          : 'linear-gradient(145deg,#C8EAF5 0%,#DFF4FA 55%,#C0E5F2 100%)',
        border:`1px solid ${dk ? 'rgba(31,200,214,.15)' : 'rgba(10,130,155,.18)'}`,
        boxShadow: dk
          ? 'inset 0 1px 0 rgba(255,255,255,.05), 0 4px 40px rgba(1,8,22,.6)'
          : '0 4px 32px rgba(10,100,140,.1)',
      }}>
        <div style={{ position:'absolute', inset:0, backgroundImage:`linear-gradient(${dk ? 'rgba(31,200,214,.08)' : 'rgba(10,130,155,.1)'} 1px,transparent 1px),linear-gradient(90deg,${dk ? 'rgba(31,200,214,.08)' : 'rgba(10,130,155,.1)'} 1px,transparent 1px)`, backgroundSize:'54px 54px', pointerEvents:'none' }}/>
        <div style={{ position:'absolute', right:'-5%', top:'-20%', width:'50%', height:'140%', background:`radial-gradient(circle,${dk ? 'rgba(15,163,177,.14)' : 'rgba(10,150,180,.2)'},transparent 65%)`, pointerEvents:'none' }}/>
        <div style={{ position:'absolute', left:'-5%', bottom:'-30%', width:'35%', height:'90%', background:`radial-gradient(circle,${dk ? 'rgba(99,102,241,.07)' : 'rgba(99,102,241,.07)'},transparent 65%)`, pointerEvents:'none' }}/>

        <div style={{ position:'relative', display:'flex', alignItems:'flex-start', gap:22, flexWrap:'wrap' }}>
          <div style={{ position:'relative', flexShrink:0 }}>
            <div style={{ position:'absolute', inset:-3, borderRadius:'50%', background:'linear-gradient(135deg,#1FC8D6 0%,#0A7B86 50%,rgba(31,200,214,.15) 100%)' }}/>
            <div style={{ position:'relative', zIndex:1, borderRadius:'50%', padding:2.5 }}>
              <Avatar name={name} s={68}/>
            </div>
            <span style={{ position:'absolute', bottom:3, right:1, zIndex:2, width:13, height:13, borderRadius:'50%', background:'#22C55E', border:`2.5px solid ${dk ? '#030C1A' : '#DFF4FA'}`, boxShadow:'0 0 7px rgba(34,197,94,.7)' }}/>
          </div>

          <div style={{ flex:1, minWidth:0 }}>
            <h2 style={{ fontSize:22, fontWeight:900, color:c.white, marginBottom:4, letterSpacing:'-.025em', lineHeight:1.25, wordBreak:'break-word' }}>{name}</h2>
            <div style={{ fontSize:13, color:c.muted, marginBottom:14, fontFamily:"'JetBrains Mono',monospace" }}>{email}</div>
            <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
              <span style={{ padding:'4px 13px', borderRadius:999, background:'rgba(15,163,177,.15)', border:'1px solid rgba(15,163,177,.3)', fontSize:12, fontWeight:700, color:c.teal, display:'flex', alignItems:'center', gap:5 }}>
                <Ic n="folder" s={11}/>{projCount} {projWord}
              </span>
              {location && (
                <span style={{ padding:'4px 13px', borderRadius:999, background: dk ? 'rgba(251,146,60,.12)' : 'rgba(251,146,60,.1)', border:'1px solid rgba(251,146,60,.25)', fontSize:12, fontWeight:600, color:'#fb923c', display:'flex', alignItems:'center', gap:5 }}>
                  <Ic n="pin" s={11}/>{location}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Info cards */}
      <Card c={c} style={{ overflow:'hidden' }}>
        <SectionTitle icon="user" label="Информация" c={c}/>
        <div className="wl-info-grid" style={{ padding:'4px 16px 18px' }}>
          {INFO_CARDS.map(({ icon, label, key, bg, border, color }) => (
            <div key={label} style={{
              display:'flex', alignItems:'center', gap:12, padding:'14px 16px',
              borderRadius:13, transition:'border-color .18s',
              border:`1px solid ${dk ? 'rgba(255,255,255,.05)' : 'rgba(10,32,40,.07)'}`,
              background: dk ? 'rgba(255,255,255,.025)' : 'rgba(10,32,40,.02)',
            }}
            onMouseEnter={e => e.currentTarget.style.borderColor = border}
            onMouseLeave={e => e.currentTarget.style.borderColor = dk ? 'rgba(255,255,255,.05)' : 'rgba(10,32,40,.07)'}>
              <div style={{ width:36, height:36, borderRadius:10, flexShrink:0, background:bg, border:`1px solid ${border}`, display:'flex', alignItems:'center', justifyContent:'center', color, boxShadow:`0 2px 10px ${color}22` }}>
                <Ic n={icon} s={15}/>
              </div>
              <div style={{ minWidth:0 }}>
                <div style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:9.5, fontWeight:700, color:c.muted, letterSpacing:'.14em', textTransform:'uppercase', marginBottom:3 }}>{label}</div>
                <div style={{ fontSize:13.5, fontWeight:600, color:c.white, wordBreak:'break-all', lineHeight:1.35 }}>{infoValues[key]}</div>
              </div>
            </div>
          ))}
        </div>
      </Card>

      {/* Recent projects */}
      <Card c={c} style={{ overflow:'hidden' }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', paddingRight:20 }}>
          <SectionTitle icon="folder" label="Последние проекты" badge={recent.length > 0 ? recent.length : undefined} c={c}/>
          {projects.length > 3 && (
            <button onClick={onGoProjects} style={{ background:'none', border:`1px solid rgba(15,163,177,.3)`, borderRadius:999, color:c.teal, fontSize:12, fontWeight:700, cursor:'pointer', padding:'4px 12px', fontFamily:"'Plus Jakarta Sans','Manrope',sans-serif", flexShrink:0 }}>Все →</button>
          )}
        </div>

        {projectsLoading ? (
          <div className="wl-projects-grid" style={{ padding:'4px 16px 16px' }}>
            {[1,2,3].map(i => <div key={i} style={{ height:160, borderRadius:14, background:c.bg2, animation:'wl-pulse 1.4s ease infinite' }}/>)}
          </div>
        ) : recent.length === 0 ? (
          <div style={{ padding:'24px 20px 28px', textAlign:'center' }}>
            <div style={{ fontSize:13.5, color:c.muted, marginBottom:14 }}>Здесь появятся ваши последние проекты</div>
            <button onClick={goNewProject} style={{ padding:'9px 22px', borderRadius:999, border:'none', background:`linear-gradient(135deg,${c.tealBright},${c.tealDeep})`, color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:"'Plus Jakarta Sans','Manrope',sans-serif", boxShadow:'0 4px 16px rgba(15,163,177,.35)' }}>+ Создать проект</button>
          </div>
        ) : (
          <div className="wl-projects-grid" style={{ padding:'4px 16px 18px' }}>
            {recent.map(p => (
              <div key={p.id} style={{ borderRadius:14, overflow:'hidden', cursor:'pointer', transition:'all .2s', border:`1px solid ${c.line}`, background: dk ? 'rgba(255,255,255,.022)' : 'rgba(10,32,40,.02)' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(31,200,214,.35)'; e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(15,163,177,.14)' }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = c.line; e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none' }}
              onClick={onGoProjects}>
                <PoolThumb previewUrl={resolveAssetUrl(p.previewUrl, p)} s={110}/>
                <div style={{ padding:'10px 14px' }}>
                  <div style={{ fontSize:13, fontWeight:700, color:c.white, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{p.name || `Проект №${projectNumberMap.get(p.id) || p.id}`}</div>
                  <div style={{ fontSize:11, color:c.muted, marginTop:2, fontFamily:"'JetBrains Mono',monospace" }}>{fmtDate(p.createdAt)}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  )
}
